import { useMutation } from 'react-query';

import { sendReminderRoute } from '@features/digitalOnboarding';
import axiosInstance from '@server/axiosInstance';

export const useSendReminder = () => {
  const { mutate: sendReminder, isLoading: isSendingReminder } = useMutation({
    mutationFn: (variables: { application_id: number }) =>
      axiosInstance.post(sendReminderRoute, variables).then((res) => res.data),
  });

  return {
    sendReminder,
    isSendingReminder,
  };
};
